import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './mixins/library.js'

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, regex, digits, min, max, numeric} from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

import store from './vuex/store'

var locale = document.getElementsByTagName("body")[0].dataset.locale;

if (locale == "en_US") {

  extend('required', {
    ...required,
    message: 'The field is required.'
  });
  
  extend('email', {
    ...email,
    message: 'The E-mail you filled in is incorrect. Please try again.'
  });

  extend('regex', {
    ...regex,
    message: 'The mobile number you filled in is incorrect. Please try again.'
  });

} else {

  extend('required', {
    ...required,
    message: 'Παρακαλούμε συμπλήρωσε το πεδίο {_field_}.'
  });
  
  extend('email', {
    ...email,
    message: 'Το email που συμπλήρωσες δεν είναι σωστό. Παρακαλούμε δοκίμασε ξανά.'
  });

  extend('regex', {
    ...regex,
    message: 'O αριθμός που συμπλήρωσες δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά.'
  });

}



// extend('otpDigits',{
//   ...digits,
//   message: "Ο προσωρινός κωδικός δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά."
// });

// extend('otpMin',{
//   ...min,
//   message: "Ο προσωρινός κωδικός δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά."
// });

// extend('otpMax',{
//   ...max,
//   message: "Ο προσωρινός κωδικός δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά."
// });

// extend('otpNumeric',{
//   ...numeric,
//   message: "Ο προσωρινός κωδικός δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά."
// });

// extend('otpRequired',{
//   ...required,
//   message: "Συμπλήρωσε τον προσωρινό κωδικό που έλαβες για να προχωρήσεις."
// });

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
 
Vue.config.productionTip = false
Vue.use(VueAxios, axios)

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
